import React, { useEffect } from 'react';
import { ChannelListMessengerProps, useChatContext } from 'stream-chat-react';

import './MessagingChannelList.css';
import { SkeletonLoader } from './SkeletonLoader';

import type { StreamChat } from 'stream-chat';

interface ChannelListMessangerPropsExtended extends ChannelListMessengerProps {
  channelID?: string;
  children?: any;
}

const MessagingChannelList: React.FC<ChannelListMessangerPropsExtended> = (props) => {
  const { children, error = false, loading, channelID } = props;

  const { client, setActiveChannel } = useChatContext();

  useEffect(() => {
    const getDemoChannel = async (client: StreamChat) => {
      const channel = client.channel('messaging', channelID);

      await channel.watch();

      if (client.user) {
        await channel.addMembers([client.user.id]);
      }

      setActiveChannel(channel);
    };

    if (!loading && !children?.props?.children?.length) {
      getDemoChannel(client);
    }
  }, [loading]); // eslint-disable-line

  if (error) {
    return (
      <div className="messaging__channel-list__message">
        Error loading conversations, please try again momentarily.
      </div>
    );
  }

  if (loading) {
    return (
      <div className="messaging__channel-list__message">
        <SkeletonLoader />
      </div>
    );
  }

  return <>{children}</>;
};

export default React.memo(MessagingChannelList);
